export default __webpack_public_path__ + "images/0xc38f41a296a4493ff429f1238e030924a1542e50.png";